module.exports = "https://static.wmbcdn.com/uniweb/images/d4acd3a01edd7d0cc41d6347aad4b454.svg";